export default __webpack_public_path__ + "static/media/gallery_02.f01311e9.jpg";